// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3H4aT","field":"styles_field__2c_Ol","fieldCol":"styles_fieldCol__3gz5o","diffCol":"styles_diffCol__1FgyX","diff":"styles_diff__22exI"};